<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/storeCost/dtl', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
			</template>
			<template #actions><el-button v-if="$checkBtnPermission('/storeCost/dtl', 'create')" size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button></template>
			<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="费用类型：">
					<el-select v-model="formInline.type" placeholder="请选择费用类型" size="small" @change="inputChange">
						<el-option v-for="item in typeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否确认：">
					<el-select v-model="formInline.isConfirm" placeholder="请选择是否确认" size="small" @change="inputChange">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="已确认" :value="true"></el-option>
						<el-option label="未确认" :value="false"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态：">
					<el-select v-model="formInline.state" placeholder="请选择状态" size="small" @change="inputChange">
						<el-option v-for="item in stateList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="申请时间：">
					<el-date-picker
						v-model="dateValue"
						clearable
						size="small"
						type="daterange"
						value-format="yyyy-MM-dd"
						format="yyyy-MM-dd"
						range-separator="~"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						@change="handleDateChange"
					></el-date-picker>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe height="560" @get-data="getListData" @row-db-click="handleEdit">
				<template #typeStr>
					<el-table-column label="费用类型" width="100" align="center">
						<template #default="scope">
							<el-link type="primary" :underline="false" @click="handleDetail(scope.row)">
								{{ scope.row.typeStr }}
							</el-link>
						</template>
					</el-table-column>
				</template>
				<template #stateStr>
					<el-table-column label="状态" width="100" align="center">
						<template #default="scope">
							<el-tag v-if="scope.row.state == 5" type="danger">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else-if="scope.row.state == 1" type="info">{{ scope.row.stateStr }}</el-tag>
							<el-tag v-else type="primary">{{ scope.row.stateStr }}</el-tag>
						</template>
					</el-table-column>
				</template>
				<template #isConfirm>
					<el-table-column label="是否确认" width="120" align="center">
						<template #default="scope">
							<el-tag v-if="scope.row.isConfirm" type="success">已确认</el-tag>
							<el-tag v-else type="danger">未确认</el-tag>
						</template>
					</el-table-column>
				</template>
				<template #isAudit>
					<el-table-column label="是否审核" width="120" align="center">
						<template #default="scope">
							<el-tag v-if="scope.row.isAudit" type="success">已审核</el-tag>
							<span v-else-if="scope.row.money < 200" type="warning"></span>
							<el-tag v-else type="danger">未审核</el-tag>
						</template>
					</el-table-column>
				</template>
				<template #isPay>
					<el-table-column label="是否支付" width="120" align="center">
						<template #default="scope">
							<el-tag v-if="scope.row.isPay" type="success">财务已确认</el-tag>
							<el-tag v-else type="danger">未确认</el-tag>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit" :type-list="typeList" :store-list="storeList"></edit>
		<!-- 详情 -->
		<detail ref="detail"></detail>
	</div>
</template>

<script>
import { GetStoreCostDtlPageList } from "@/api/storeCostApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import edit from "./edit.vue";
import detail from "./detail.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "备用金明细"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			typeList: [],
			dateValue: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				type: 0,
				storeKeyId: "",
				isConfirm: null,
				startTime: null,
				endTime: null,
				state: 0
			},
			storeList: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "createTime",
					label: "申请时间",
					width: "170",
					align: "center",
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "120",
					align: "center",
				},
				{
					slot: "typeStr",
					label: "费用类型",
					minWidth: "100",
					align: "center",
				},
				{
					slot: "stateStr",
					label: "状态",
					minWidth: "100",
					align: "center",
				},
				{
					prop: "content",
					label: "内容",
					minWidth: "200",
					align: "center"
				},
				{
					prop: "money",
					label: "金额",
					minWidth: "100",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					slot: "isConfirm",
					label: "是否确认",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "confirmUserName",
					label: "确认人",
					align: "center"
				},
				{
					prop: "confirmTime",
					label: "确认时间",
					align: "center",
					width: "170"
				},
				{
					slot: "isAudit",
					label: "是否审核",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "auditUserName",
					label: "审核人",
					align: "center"
				},
				{
					prop: "auditTime",
					label: "审核时间",
					align: "center",
					width: "170"
				},
				{
					slot: "isPay",
					label: "是否支付",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "payUserName",
					label: "财务确认人",
					align: "center",
					width: "120"
				},
				{
					prop: "payTime",
					label: "财务确认时间",
					align: "center",
					width: "170"
				},
				{
					prop: "creator",
					label: "申请人",
					width: "120",
					align: "center"
				}
			],
			stateList: []
		};
	},
	// 注册组件
	components: {
		edit,
		detail
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
		this.GetEnumConfigListByCode();
		this.GeStateListByCode();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		handleDateChange(val) {
			if (val) {
				this.formInline.startTime = val[0];
				this.formInline.endTime = val[1];
			} else {
				this.formInline.startTime = null;
				this.formInline.endTime = null;
			}
			this.search();
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		//显示编辑界面
		handleEdit(row) {
			this.$refs.edit.editShow(row);
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetStoreCostDtlPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 获取费用类型
		GetEnumConfigListByCode() {
			const paramer = {
				code: "CostDtlType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.typeList = [];
						res.data.forEach((item) => {
							this.typeList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
						this.typeList.unshift({
							keyId: 0,
							value: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取费用类型失败!");
				});
		},
		// 获取状态
		GeStateListByCode() {
			const paramer = {
				code: "StoreCostState"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.stateList = [];
						res.data.forEach((item) => {
							this.stateList.push({
								keyId: parseInt(item.code),
								value: item.name
							});
						});
						this.stateList.unshift({
							keyId: 0,
							value: "全部"
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态失败!");
				});
		},
		// 详情
		handleDetail(row) {
			this.$refs.detail.showDetail(row.keyId);
		}
	}
};
</script>

<style scoped></style>
